(function () {
  // 1. Reload venstre del af cart drawer og bevar placeholder
  function reloadUpsellContainer() {
    const wrapper = document.querySelector('.cm-cart-drawer-left');
    if (!wrapper) return;

    fetch(window.location.pathname + '?section_id=cart-drawer')
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newDrawerContent = doc.querySelector('.cm-cart-drawer-left');

        if (newDrawerContent) {
          // Gem eksisterende placeholder (hvis den findes)
          const existingPlaceholder = wrapper.querySelector('#cm-upsell-mobile-placeholder');

          wrapper.innerHTML = newDrawerContent.innerHTML;

          // Sæt placeholder tilbage, hvis nødvendig
          if (existingPlaceholder && !wrapper.querySelector('#cm-upsell-mobile-placeholder')) {
            wrapper.appendChild(existingPlaceholder);
          }

          // Indsæt anbefalinger igen efter reload
          insertProductRecommendationsOnce();
        }
      });
  }

  // 2. Indsæt <product-recommendations> én gang
  function insertProductRecommendationsOnce() {
    const placeholder = document.querySelector("#cm-upsell-mobile-placeholder");

    if (!placeholder) return;

    if (placeholder.querySelector("product-recommendations")) return;

    const productRecommendations = document.createElement("product-recommendations");
    productRecommendations.setAttribute("data-product-id", ShopifyAnalytics.meta.product.id);
    productRecommendations.setAttribute("intent", "related");
    productRecommendations.setAttribute("limit", "6");

    placeholder.appendChild(productRecommendations);
  }

  // 2b. Overvåg for og fjern dubletter af anbefalingssektioner
function removeDuplicateUpsellContainers() {
  const placeholder = document.querySelector('#cm-upsell-mobile-placeholder');
  if (!placeholder) return;

  const selectors = ['.cm-upsell-container', 'product-recommendations'];

  selectors.forEach(selector => {
    const nodes = placeholder.querySelectorAll(selector);
    if (nodes.length > 1) {
      nodes.forEach((el, i) => {
        if (i > 0) el.remove();
      });
    }
  });
}

// Start observer for dubletter
document.addEventListener('DOMContentLoaded', function () {
  const placeholder = document.querySelector('#cm-upsell-mobile-placeholder');
  if (!placeholder) return;

  const observer = new MutationObserver(removeDuplicateUpsellContainers);
  observer.observe(placeholder, {
    childList: true,
    subtree: true
  });
});


  // 3. Når cart drawer ændrer sig → reload venstreside og tilføj upsell
  document.addEventListener('DOMContentLoaded', function () {
    const drawer = document.querySelector('#site-cart-sidebar');
    if (!drawer) return;

    const observer = new MutationObserver(() => {
      const container = drawer.querySelector('.cm-cart-drawer-left');
      if (container) {
        reloadUpsellContainer();
      }
    });

    observer.observe(drawer, { childList: true, subtree: true });
  });

  // 4. Luk cart drawer korrekt
  document.addEventListener("click", function (e) {
    const btn = e.target.closest("[data-cart-drawer-close]");
    if (!btn) return;

    const drawer = document.querySelector("cart-drawer");
    if (drawer && typeof drawer.closeCartDrawer === "function") {
      drawer.closeCartDrawer();
    }
  });

  // 5. Tilføj mobil-luk-knap ved section load (hvis relevant)
  document.addEventListener('shopify:section:load', function (event) {
    if (event.detail?.sectionId === 'cart-drawer') {
      insertMobileCloseButton?.();
    }
  });

})();
